<template>
  <div id="memberListContainer">
    <vs-table hover-flat v-if="members && members.length" :data="members">
      <template slot="thead">
        <vs-th v-text="$t('no')"></vs-th>
        <vs-th v-text="$t('caller_company_name')" v-if="activeColumns.includes('caller_company_name')"></vs-th>
        <vs-th v-text="$t('member_name')" v-if="activeColumns.includes('member_name')"></vs-th>
        <vs-th v-text="$t('mobile')" v-if="activeColumns.includes('mobile')"></vs-th>
        <vs-th v-text="$t('landline')" v-if="activeColumns.includes('landline')"></vs-th>
        <vs-th class="text-center" v-text="$t('age')" v-if="activeColumns.includes('age')"></vs-th>
        <vs-th v-text="$t('groups')" v-if="activeColumns.includes('groups')"></vs-th>
        <vs-th v-text="$t('levels')" v-if="activeColumns.includes('levels')"></vs-th>
        <vs-th v-text="$t('email')" v-if="activeColumns.includes('email')"></vs-th>
        <vs-th v-text="$t('address')" v-if="activeColumns.includes('address')"></vs-th>
        <vs-th v-text="customField.name" :key="thCustomFieldKey" v-for="(customField, thCustomFieldKey) in customFields" v-if="activeColumns.includes(`custom_field_${customField.id}`)"></vs-th>
        <vs-th v-text="$t('join_now')"></vs-th>
        <vs-th v-text="$t('time')"></vs-th>
        <vs-th class="text-center" v-text="$t('function')"></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr v-for="(tr, indextr) in data" :key="indextr">
          <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
          <vs-td v-if="activeColumns.includes('caller_company_name')" :data-tr-title="$t('caller_company_name')">
            <a href="#" v-text="tr.company_name" @click.prevent="$emit('callerCompanyPopup', tr.company_name)"></a>
          </vs-td>
          <vs-td v-if="activeColumns.includes('member_name')" :data-tr-title="$t('member_name')">
            <a href="#" v-text="tr.name" @click.prevent="$emit('openOutboundPopup', tr.id)"></a>
          </vs-td>
          <vs-td v-if="activeColumns.includes('mobile')" :data-tr-title="$t('mobile')">
            <div v-if="$store.getters.hasCompanyPermission('company_can_click_to_call_outbound_call_popup')">
              <a class="d-inline-block mr-2" href="#" @click.prevent="openOutboundPopup(tr.mobile)" v-if="tr.mobile && tr.mobile.length > 0" >
                 {{ tr.mobile }}
              </a>
              <div class="d-inline-block mr-2" v-else>
                <span>--</span>
              </div>
              <vs-button v-if="tr.mobile && tr.mobile.length > 0" radius color="primary" type="border" icon="dialpad" size="small" class="d-inline-block" @click.prevent="openOutboundPopup(tr.mobile)"></vs-button>
            </div>
            <div v-else>
              <div class="d-inline-block mr-2" v-if="tr.mobile && tr.mobile.length > 0">
                <a v-if="$stringHelper.contentIsMobile(tr.mobile)" href="#" @click.prevent="openSendSmsPopup(tr.mobile)" v-text="tr.mobile"></a>
                <span v-else v-text="tr.mobile"></span>
              </div>
              <div class="d-inline-block mr-2" v-else>
                <span>--</span>
              </div>
              <click-to-call v-if="tr.mobile && tr.mobile.length > 0" class="d-inline-block" :phone-number="tr.mobile"></click-to-call>
            </div>
          </vs-td>
          <vs-td v-if="activeColumns.includes('landline')" :data-tr-title="$t('landline')">
            <div v-if="$store.getters.hasCompanyPermission('company_can_click_to_call_outbound_call_popup')">
              <a class="d-inline-block mr-2" href="#" @click.prevent="openOutboundPopup(tr.landline)" v-if="tr.landline && tr.landline.length > 0" >
                {{ tr.landline }}
              </a>
              <div class="d-inline-block mr-2" v-else>
                <span>--</span>
              </div>
              <vs-button v-if="tr.landline && tr.landline.length > 0" radius color="primary" type="border" icon="dialpad" size="small" class="d-inline-block" @click.prevent="openOutboundPopup(tr.landline)"></vs-button>
            </div>
            <div v-else>
              <div class="d-inline-block mr-2" v-if="tr.landline && tr.landline.length > 0">
                <a v-if="$stringHelper.contentIsMobile(tr.landline)" href="#" @click.prevent="openSendSmsPopup(tr.landline)" v-text="tr.landline"></a>
                <span v-else v-text="tr.landline"></span>
              </div>
              <click-to-call v-if="tr.landline && tr.landline.length > 0" class="d-inline-block" :phone-number="tr.landline"></click-to-call>
            </div>
          </vs-td>
          <vs-td v-if="activeColumns.includes('age')" class="text-center" v-text="tr.age" :data-tr-title="$t('age')"></vs-td>
          <vs-td v-if="activeColumns.includes('groups')" v-text="tr.member_group_name" :data-tr-title="$t('groups')"></vs-td>
          <vs-td v-if="activeColumns.includes('levels')" v-text="tr.member_level_name" :data-tr-title="$t('levels')"></vs-td>
          <vs-td v-if="activeColumns.includes('email')" v-text="tr.email" :data-tr-title="$t('email')"></vs-td>
          <vs-td v-if="activeColumns.includes('address')" v-text="tr.address" :data-tr-title="$t('address')"></vs-td>
          <vs-td :key="tdCustomFieldKey" v-for="(customField, tdCustomFieldKey) in customFields" v-if="activeColumns.includes(`custom_field_${customField.id}`)" :data-tr-title="customField.name">
            <template v-for="(customFieldData, customFieldDataKey) in tr.custom_fields">
              <span :key="customFieldDataKey" v-if="customFieldData.custom_field_id == customField.id">
                {{ customFieldData.value }}
              </span>
            </template>
          </vs-td>
          <vs-td v-text="tr.created_at" :data-tr-title="$t('join_now')"></vs-td>
          <vs-td v-text="tr.created_at_time" :data-tr-title="$t('time')"></vs-td>
          <vs-td>
            <div class="flex justify-center">
              <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click="$emit('deleteMember', tr.id)"></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
      <div v-text="$t('no_record')"></div>
    </vs-alert>

  </div>
</template>

<script>
import ClickToCall  from '@/components/buttons/ClickToCall'
import {EventBus} from '@/../eventbus'
import Utils from '@/helpers/utils'

export default {
  name: 'Shared.Members.List',
  components: {
    ClickToCall
  },
  props: {
    members: {
      type: [Object, Array],
      required: true
    },
    customFields: {
      type: [Object, Array],
      required: true
    },
    activeColumns: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    openSendSmsPopup (number) {
      EventBus.$emit('initSendSmsPopup', number)
    },
    openOutboundPopup (number) {
      // Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-popup')
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-popup', {phoneNumber: number})
    }
  }
}
</script>

<style lang="scss" scoped>
  #memberListContainer {
    table {
      thead,
      tbody {
        tr {
          td,
          th {
            //&:nth-child(1) {
            //  width: 5%;
            //}
            //&:nth-child(2) {
            //  width: 10%;
            //}
            //&:nth-child(3) {
            //  width: 5%;
            //}
            //&:nth-child(4) {
            //  width: 10%;
            //}
            //&:nth-child(5) {
            //  width: 5%;
            //}
            //&:nth-child(6) {
            //  width: 5%;
            //}
            //&:nth-child(7) {
            //  width: 5%;
            //}
            //&:nth-child(8) {
            //  width: 5%;
            //}
            //&:nth-child(9) {
            //  width: 10%;
            //}
            //&:nth-child(10) {
            //  width: 5%;
            //}
            //&:last-child {
            //  width: 5%;
            //}
          }
        }
      }
    }
  }
</style>
